import API from "../axiosConfig";

// export const getLines = async () => {
//   try {
//     const response = await API.get("/lines");
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching lines:", error);
//     throw error;
//   }
// };

// export const getLineById = async (id) => {
//   try {
//     const response = await API.get(`/lines/${id}`);
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

export const getlinesByStreetId = async (streetId) => {
  try {
    const response = await API.get("/lines/by_street/" + streetId);
    return response.data;
  } catch (error) {
    console.error("Error fetching lines:", error);
    throw error;
  }
};

export const createLine = async (lineData) => {
  try {
    const response = await API.post("/lines", lineData);
    return response.data;
  } catch (error) {
    console.error("Error creating section:", error);
    throw error;
  }
};

export const updateLine = async (lineId, lineData) => {
  try {
    const response = await API.put(`/lines/${lineId}`, lineData);
    return response.data;
  } catch (error) {
    console.error("Error updating section:", error);
    throw error;
  }
};

export const deleteLine = async (lineId) => {
  try {
    const response = await API.delete(`/lines/${lineId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting section:", error);
    throw error;
  }
};
